<template>
  <modal name="search-mobile-panel" :delay="1000" :scrollable='true' width="100%" height="auto" classes="inner" :clickToClose="false">
    <section class="modal">
      <form id="mobile_condition">
        <div class="c-container">
          <!-- side-column -->
          <div class="side-column">
            <div class="c-midashi u-search-title">さらに絞り込む</div>
            <div class="u-tx-center submit-btn" style="max-width: 100%;">
              <a v-on:click="this.resetParams">
                <span class="border-btn-tx">リセット</span>
              </a>
            </div>
            <div class="u-tx-center submit-btn u-mt-30" style="max-width: 100%;">
              <a class="cart-in-btn u-tx-white" @click="changeIsShow()">
                <span class="border-btn-tx">検索条件を反映する</span>
              </a>
            </div>
            <div class="u-tx-center side-item-search">
              結果を表示する：
              <span class="mobile-search-total-products-num">{{this.counts.total}}件</span>
            </div>            
            <div v-if="false">          
              <!-- キーワードから探す -->
              <div class="side-item-search header-top-freesearch sp-only">
                <input class="free-search-input" name="keyword" placeholder="キーワードから探す" v-model="params.keyword" v-on:keydown.enter.exact.prevent v-on:keyup.enter.exact="changeIsShow()">
              </div>
              <!-- キーワードから探す ここまで -->
            </div>
            <dl class="side-item-search">
              <div>
                <dt>在庫から探す</dt>
                <dd><label class="label-chk"><input type="checkbox" v-model="params.is_stockable"/><span>在庫あり（{{this.counts.stockable || 0}}）</span></label></dd>
              </div>
              <div v-if="this.isSignedIn">
                <dt>購入済み商品</dt>
                <dd>
                  <label class="label-chk"><input type="checkbox"  v-model="params.buy_status" value="purchased"/><span>購入済み（{{this.counts.buy_status.purchased || 0}}）</span></label>
                  <label class="label-chk"><input type="checkbox"  v-model="params.buy_status" value="pre_purchased"/><span>未購入商品（{{this.counts.buy_status.pre_purchased || 0}}）</span></label>
                </dd>
                <dt>自分が登録した商品</dt>
               <dd>
                  <label class="label-chk"><input type="checkbox"  v-model="params.favorite_status" value="favorited"/><span>お気に入り（{{this.counts.favorite_status.favorited || 0}}）</span></label>
                  <label class="label-chk"><input type="checkbox"  v-model="params.notify_status" value="notified"/><span>入荷通知（{{this.counts.notify_status.notified || 0}}）</span></label>
               </dd>                        
              </div>
              <div>
                <dt>種類</dt>
                  <dd>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="ramen" /><span>ラーメン（{{this.counts.category.ramen || 0}}）</span></label>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="dipping" /><span>つけ麺（{{this.counts.category.dipping || 0}}）</span></label>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="no_soup" /><span>まぜそば（{{this.counts.category.no_soup || 0}}）</span></label>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="inspire_ramen" /><span>二郎インスパイア（{{this.counts.category.inspire_ramen || 0}}）</span></label>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="inspire_no_soup" /><span>二郎インスパイア汁なし（{{this.counts.category.inspire_no_soup || 0}}）</span></label>                    
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="curry" /><span>カレー（{{this.counts.category.curry || 0}}）</span></label>
                    <label class="label-chk"><input type="checkbox" v-model="params.category" value="other" /><span>その他（{{this.counts.category.other || 0}}）</span></label>
                  </dd>
              </div>
              <div>
                <dt>あっさり/こってり</dt>
                <dd>
                  <label class="label-chk"><input type="checkbox"  v-model="params.taste" value="super_light" /><span>超あっさり（{{this.counts.taste.super_light || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox"  v-model="params.taste" value="light" /><span>あっさり（{{this.counts.taste.light || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox"  v-model="params.taste" value="medium" /><span>普通（{{this.counts.taste.medium || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox"  v-model="params.taste" value="heavy" /><span>こってり（{{this.counts.taste.heavy || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox"  v-model="params.taste" value="super_heavy" /><span>超こってり（{{this.counts.taste.super_heavy || 0}}）</span></label>
                </dd>
              </div>
              <div>
                <dt>味</dt>
                <dd>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="soy" /><span>醤油（{{this.counts.sauce.soy || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="salt" /><span>塩（{{this.counts.sauce.salt || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="miso" /><span>味噌（{{this.counts.sauce.miso || 0}}）</span></label>          
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="tonkotsu" /><span>豚骨（{{this.counts.sauce.tonkotsu || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="tonkotsu_soy" /><span>豚骨醤油（{{this.counts.sauce.tonkotsu_soy || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="seafood_tonkotsu" /><span>魚介豚骨（{{this.counts.sauce.seafood_tonkotsu || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="niboshi" /><span>煮干し（{{this.counts.sauce.niboshi || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="chicken" /><span>鶏白湯（{{this.counts.sauce.chicken || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="house" /><span>家系（{{this.counts.sauce.house || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="umakara" /><span>旨辛（{{this.counts.sauce.umakara || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="tantan" /><span>担々麺（{{this.counts.sauce.tantan || 0}}）</span></label>                            
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="unique" /><span>個性派（{{this.counts.sauce.unique || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.sauce" value="merchandise_sets" /><span>グッズ・セット（{{this.counts.sauce.merchandise_sets || 0}}）</span></label>
                </dd>
              </div>
              <div>
                <dt>薄味/濃口</dt>
                <dd>
                <label class="label-chk"><input type="checkbox" v-model="params.shading" value="super_light" /><span>超薄味（{{this.counts.shading.super_light || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.shading" value="light" /><span>薄味（{{this.counts.shading.light || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.shading" value="medium" /><span>普通（{{this.counts.shading.medium || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.shading" value="heavy" /><span>濃味（{{this.counts.shading.heavy || 0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.shading" value="super_heavy" /><span>超濃味（{{this.counts.shading.super_heavy || 0}}）</span></label>
                </dd>
              </div>
              <div>
                <dt>細麺/太麺</dt>
                <dd>
                <label class="label-chk"><input type="checkbox" v-model="params.noodle" value="super_thin" /><span>極細麺（{{this.counts.noodle.super_thin ||0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.noodle" value="thin" /><span>細麺（{{this.counts.noodle.thin ||0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.noodle" value="medium" /><span>普通（{{this.counts.noodle.medium ||0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.noodle" value="thick" /><span>太麺（{{this.counts.noodle.thick ||0}}）</span></label>
                <label class="label-chk"><input type="checkbox" v-model="params.noodle" value="super_thick" /><span>極太麺（{{this.counts.noodle.super_thick ||0}}）</span></label>
                </dd>
              </div>
            </dl>
            <div style="margin-bottom: 150px;">
              <div class="u-tx-center">
                結果を表示する：
                <span class="mobile-search-total-products-num">{{this.counts.total}}件</span>
              </div>
              <div class="side-item-search u-tx-center submit-btn" style="max-width: 100%;">
                <a class="cart-in-btn u-tx-white" @click="changeIsShow()">
                  <span class="border-btn-tx">検索条件を反映する</span>
                </a>
              </div>
            </div>        
          </div>                
        </div>
      </form>
    </section>
  </modal>
</template>

<script>
export default {
  props: {
    isShow: false,
    searchParams: {},
    isSignedIn: false,
    counts: {}    

  },
  data: function(){
    return{
      modalIsShow: true,
      params: {}
    }
  },
  watch: {
    searchParams: function(newVal, oldVal){
      this.params = newVal
    },    
    isShow: function(val){
      this.modalIsShow = this.isShow
    },
    modalIsShow: function(val){
      if(val == true){
        this.$modal.show('search-mobile-panel');
      }
      else{
        this.$modal.hide('search-mobile-panel');
      }
    }    
  },
  mounted: function(){
    this.params = this.$props.searchParams
    this.modalIsShow = this.isShow
  },  
  methods: {
    resetParams: function(){
      this.$emit('reset_params')

    },    
    changeIsShow: function(event){
      this.$emit('change_show')
      this.modalIsShow = false
    }
  }

};
</script>

<style scoped>
  .scrollable{
    z-index: 999999999;
  }
  .inner {
    display: table-cell;
    padding: 5em 0em 0em 0em; /* モーダル外側の余白 */
    vertical-align: middle;
  }
  .modal {
    margin: 0 auto;
    padding: 1em 0.5em; /* モーダル内側の余白 */
    /* max-width: 550px; */
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  

</style>